'use strict'

/**axios封装
 * 请求拦截、相应拦截、错误统一处理
 */

import axios from 'axios';
import {
  Message,
  MessageBox
} from 'element-ui'
import global from '../assets/js/global_variable.js';
// import utils from '../utils/tools.js';

const host = window.location.protocol + '//' + window.location.host // 动态域名

// axios 配置

// 环境切换
if (process.env.NODE_ENV == 'development') {
  axios.defaults.baseURL = global.developmentEnvironment;
} else if (process.env.NODE_ENV == 'debug') {
  axios.defaults.baseURL = global.developmentEnvironment;
} else if (process.env.NODE_ENV == 'production') {
  axios.defaults.baseURL = global.developmentEnvironment;
}

axios.defaults.responseType = 'json';
axios.defaults.timeout = 15000; // 请求超时时间

// 请求拦截器
axios.interceptors.request.use(config => { // 这里的config包含每次请求的内容

  let type = Object.prototype.toString

  let token = ''

  if (sessionStorage.getItem('token')) {

    token = sessionStorage.getItem('token')

  }

  console.log("----------------token:" + token)

  if (type.call(config.data) == "[object FormData]") {

    config.headers = {
      'JwtIot': token ? `${token}` : '', // token
      // 'Access-Control-Allow-Methods': 'POST, GET, PUT, DELETE, OPTIONS', // 响应类型
      'Content-Type': 'multipart/form-data',
      'Cache-Control': 'no-cache',
      'Access-Control-Allow-Origin': '*',
      'X-Requested-With': 'XMLHttpRequest',
    };

  } else if (type.call(config.data) == "[object String]" && config.responseType !== "undefined" && config
    .responseType === "blob") {

    if (config.data) {

      config.data = JSON.parse(config.data);

    }

    config.headers = {
      'JwtIot': token ? `${token}` : '', // token
      // 'Access-Control-Allow-Methods': 'POST, GET, PUT, DELETE, OPTIONS', // 响应类型
      // 'Content-Disposition': 'attachment;filename=total.xls',
      'Content-Type': 'application/msexcel;charset=UTF-8',
      'Cache-Control': 'no-cache',
      'Access-Control-Allow-Origin': '*',
      'X-Requested-With': 'XMLHttpRequest',
    };

  } else if (type.call(config.data) == "[object Object]") {


    config.headers = {
      'JwtIot': token ? `${token}` : '', // token
      // 'Access-Control-Allow-Methods': 'POST, GET, PUT, DELETE, OPTIONS', // 响应类型
      'Cache-Control': 'no-cache',
      'Access-Control-Allow-Origin': '*',
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json',
    };

  } else {

    if (config.data) {

      config.data = JSON.parse(config.data);

    }

    config.headers = {
      // 'Authorization': token ? `Bearer ${token}` : '', // token
      'JwtIot': token ? `${token}` : '', // token
      // 'Access-Control-Allow-Methods': 'POST, GET, PUT, DELETE, OPTIONS', // 响应类型
      'Cache-Control': 'no-cache',
      'Access-Control-Allow-Origin': '*',
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    };

  }

  config.withCredentials = true; //在跨域请求时携带用户凭证cookie

  console.log("----------------config.headers:" + JSON.stringify(config.headers))

  return config;

}, (error) => {
  console.log("----------------error:" + JSON.stringify(error))
  return error;

});

// 响应拦截器
axios.interceptors.response.use(response => {
  response.headers = {
    'Access-Control-Allow-Origin': '*',
  };

  console.log("接口响应:", JSON.stringify(response))

  if (response.data.code !== 0) {

    MessageBox.confirm('您碰到了错误，请检查参数', '系统提示', {
      // confirmButtonText: '重新登录',
      cancelButtonText: '取消',
      type: 'warning',
      beforeClose: (action, instance, done) => {
        if (action === 'confirm') {
          // sessionStorage.setItem('jwtIot', '') // 重置token
          // window.location.replace(host)
          done();
        } else {
          done();
        }
      }

    })

  }

  return response;

}, (err) => {
  if (err && err.response) {



    if (err.response.status == 401) {

      MessageBox.confirm('用户登录已过期，请点击重新登录', '系统提示', {
        confirmButtonText: '重新登录',
        cancelButtonText: '取消',
        type: 'warning',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            sessionStorage.setItem('jwtIot', '') // 重置token
            window.location.replace(host)
          } else {
            done();
          }
        }

      })

    }

    // switch (err.response.status) {
    //   case 400:
    //     err.message = '请求错误';
    //     break;

    //   case 401:
    //     err.message = '未授权，请登录';
    //     break;

    //   case 403:
    //     err.message = '拒绝访问';
    //     break;

    //   case 404:
    //     // err.message = `请求地址出错: ${err.response.config.url}`;
    //     err.message = '请求地址出错';
    //     throw err;
    //     break;

    //   case 408:
    //     err.message = '请求超时';
    //     break;

    //   case 500:
    //     err.message = '服务器内部错误';
    //     break;

    //   case 501:
    //     err.message = '服务未实现';
    //     break;

    //   case 502:
    //     err.message = '网关错误';
    //     break;

    //   case 503:
    //     err.message = '服务不可用';
    //     break;

    //   case 504:
    //     err.message = '网关超时';
    //     break;

    //   case 505:
    //     err.message = 'HTTP版本不受支持';
    //     break;

    //   default:
    //     err.message = err.response.data.message;
    //     break;

    // }
  }
  return err;
});

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */

function fetchPost(url, params, resType = "") {
  return new Promise((resolve, reject) => {

    if (resType === "blob") {
      axios.defaults.responseType = 'blob';
    } else {
      axios.defaults.responseType = 'json';
    }

    console.log("请求--url:" + url)
    console.log("请求--params:" + JSON.stringify(params))

    axios.post(url, params).then(response => {
      console.log("响应--res:" + JSON.stringify(response.data))
      resolve(response);

    }, err => {
      console.log("响应--err:" + JSON.stringify(err))
      reject(err);
    }).catch(error => {
      console.log("请求-响应--error:" + JSON.stringify(error))
      reject(error);
    });
  });
}

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */

function fetchGet(url, params, resType = "") {

  return new Promise((resolve, reject) => {
    if (resType === "blob") {
      axios.defaults.responseType = 'blob';
    } else {
      axios.defaults.responseType = 'json';
    }

    axios.get(url, {
      params: params
    }).then(response => {

      resolve(response);

    }, err => {
      reject(err);
    }).catch(error => {
      reject(error);
    });
  });
}

/**
 * put方法，对应put请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */

function fetchPut(url, params, resType = "") {
  return new Promise((resolve, reject) => {

    if (resType === "blob") {
      axios.defaults.responseType = 'blob';
    } else {
      axios.defaults.responseType = 'json';
    }

    axios.put(url, params).then(response => {

      resolve(response);

    }, err => {
      reject(err);
    }).catch(error => {
      reject(error);
    });
  });
}

/**
 * delete方法，对应delete请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */

function fetchDelete(url, params, resType = "") {
  return new Promise((resolve, reject) => {

    if (resType === "blob") {
      axios.defaults.responseType = 'blob';
    } else {
      axios.defaults.responseType = 'json';
    }

    axios.delete(url, params).then(response => {

      resolve(response);

    }, err => {
      reject(err);
    }).catch(error => {
      reject(error);
    });
  });
}

export default {
  // 登录
  _login(params) {
    return fetchPost('/api/auth/loginByPwd', params);
  },

  // 获取用户信息
  _getUserInfo(params) {
    return fetchPost('/api/user/info', params);
  },

  // 获取验证码
  _getVerifyCode(params) {
    return fetchGet('/test/api/sms/openApi/verifyCode', params);
  },

  // 注册
  _getRegister(params) {
    return fetchPost('/test/api/user/register', params);
  },

  // 忘记密码
  _forgetPassword(params) {
    return fetchPut('/test/api/user/password', params);
  },

  // 公寓列表
  _getApartmentList(params) {
    return fetchPost('/api/apartment/list', params);
  },

  // 获取公寓信息
  _getApartmentInfo(params) {
    return fetchGet('/test/api/apartment/apartment', params);
  },

  // 新增公寓
  _addApartmentInfo(params) {
    return fetchPost('/api/apartment/add', params);
  },

  // 修改公寓信息
  _putApartmentInfo(params) {
    return fetchPost('api/apartment/edit', params);
  },

  // 删除公寓
  _deleteApartment(params) {
    return fetchPost('/api/apartment/remove', params);
  },

  // 房间列表
  _getRoomList(params) {
    return fetchPost('/api/room/list', params);
  },

  // 公寓的管理员列表
  _getJanitorList(params) {
    return fetchPost('/api/apartment/janitorList', params);
  },
  // 公寓的管理员详情
  _getJanitorDetail(params) {
    return fetchPost('/api/apartment/janitorDetail', params);
  },

  //房东为公寓添加管理员
  _landlordAddJanitor(params) {
    return fetchPost('/api/apartmentUser/landlordAddJanitor', params);
  },
  //编辑公寓管理员--修改管理员(在某个公寓的角色)
  _landlordEditJanitor(params) {
    return fetchPost('/api/apartmentUser/landlordEditJanitor', params);
  },
  //删除管理员
  _landlordRemoveJanitor(params) {
    return fetchPost('/api/apartmentUser/landlordRemoveJanitor', params);
  },

  // v公寓--管理员在某个公寓的所有角色
  _getJanitorAppRoleListByApartmentId(params) {
    return fetchPost('/api/appRoleApartmentUser/janitorAppRoleListByApartmentId', params);
  },

  // 获取房间信息
  _getRoomInfo(params) {
    return fetchPost('/api/room/detail', params);
  },
  // 获取房间成员
  _getRoomUserList(params) {
    return fetchPost('/api/room/userList', params);
  },

  // 新增房间
  _addRoom(params) {
    return fetchPost('/api/room/add', params);
  },

  _batchAddRoom(params){
    return fetchPost('/api/room/batchAdd', params);
  },

  // 为房间添加租户
  _landlordOrJanitorAddTenant(params) {
    return fetchPost('/api/apartmentUser/landlordOrJanitorAddTenant', params);
  },

  // 修改房间信息
  _putHomeInfo(params) {
    return fetchPost('/api/room/edit', params);
  },

  // 删除未出租的房间
  _deleteNoRentedOutRoom(params) {
    return fetchPost('/api/room/remove', params);
  },

  _deleteHome(params) {
    return fetchDelete('/test/api/apartment/apartmentAsset' + params, null);
  },

  // 设备列表
  _getDevicelist(params) {
    return fetchGet('/test/api/apartment/apartmentDevice', params);
  },

  // 注册设备
  _registerDevice(params) {
    return fetchPost('/test/api/apartment/apartment/device', params);
  },

  // 查找设备
  _getRegisterDeviceInfo(params) {
    return fetchGet('/test/api/apartment/apartment/device', params);
  },

  // 新增设备
  _addDeviceInfo(params) {
    return fetchPost('/test/api/apartment/apartmentDev', params);
  },

  // 修改设备信息
  _putDeviceInfo(params) {
    return fetchPut('/test/api/apartment/apartmentDevice', params);
  },

  // 删除设备
  _deleteDevice(params) {
    return fetchDelete('/test/api/apartment/apartmentDev' + params, null);
  },

  // 人员列表
  _getUserlist(params) {
    return fetchGet('/test/api/apartment/apartmentUser', params);
  },

  // 获取人员信息
  _getUserDetail(params) {
    return fetchGet('/test/api/apartment/apartmentUser', params);
  },

  // 新增人员
  _addUserInfo(params) {
    return fetchPost('/test/api/apartment/apartmentTenement', params);
  },

  // 修改人员信息
  _putUserInfo(params) {
    return fetchPut('/test/api/apartment/apartmentUser', params);
  },

  // 删除人员
  _deleteUser(params) {
    return fetchDelete('/test/api/apartment/apartmentUser' + params, null);
  },

  // 获取开锁记录
  _getLockRecordList(params) {
    return fetchGet('/test/api/apartment/unlockHistory', params);
  },

  // 删除开锁记录
  _deleteLockRecord(params) {
    return fetchDelete('/test/api/apartment/unlockHistory' + params, null);
  },

  // 获取操作记录
  _getOperatingRecordList(params) {
    return fetchGet('/test/api/apartment/operatingRecord', params);
  },

  // 删除操作记录
  _deleteOperatingRecord(params) {
    return fetchDelete('/test/api/apartment/operatingRecord' + params, null);
  },

  // 设备模块更换房间
  _putDeviceChangeRoom(params) {
    return fetchPut('/test/api/apartment/apartmentDeviceAsset', params);
  },

  // 用户模块更换房间
  _putUserChangeRoom(params) {
    return fetchPut('/test/api/apartment/apartmentUserAsset', params);
  },


  // 查询所有产品类型
  _getProductList(params) {
    return fetchGet('/test/api/user/products', params);
  },
  // 新增产品类型
  _addDevice(params) {
    return fetchPost('/test/api/user/product', params);
  },
  // 上传固件版本
  _UploadVersion(params) {
    return fetchPost('/test/api/user/uploadVersion', params);
  },
  // 创建升级任务
  _upOTA(params) {
    return fetchPost('/test/api/user/updateTask', params);
  },


  // app角色列表
  _getAppRoleList(params) {
    return fetchPost('/api/appRole/list', params);
  },
  // app角色详情
  _getAppRoleDetail(params) {
    return fetchPost('/api/appRole/detail', params);
  },
  // app权限--获取所有管理公寓的权限
  _getAppMenuList(params) {
    return fetchPost('/api/appMenu/list', params);
  },
  // app角色添加
  _addAppRole(params) {
    return fetchPost('/api/appRole/add', params);
  },
  // app角色编辑
  _editAppRole(params) {
    return fetchPost('/api/appRole/edit', params);
  },
  // app角色详删除
  _removeAppRole(params) {
    return fetchPost('/api/appRole/remove', params);
  },


  // version列表
  _getVersionList(params) {
    return fetchPost('/api/version/list', params);
  },
  // version添加
  _addVersion(params) {
    return fetchPost('/api/version/add', params);
  },
  // version添加
  _delVersion(params) {
    return fetchPost('/api/version/delete', params);
  },
  // task列表
  _getOtaTaskList(params) {
    return fetchPost('/api/versionOtaTask/list', params);
  },
  // task添加
  _addTask(params) {
    return fetchPost('/api/versionOtaTask/add', params);
  },
  // task详情
  _getOtaTaskDetail(params) {
    return fetchPost('/api/versionOtaTask/detail', params);
  },
  // task删除
  _delTask(params) {
    return fetchPost('/api/versionOtaTask/delete', params);
  },

  // 发UI消息
  _sendUiMsg(params) {
    return fetchPost('/api/wxMpMsg/sendUiMsg', params);
  },
}



// WEBPACK FOOTER //
// ./src/api/http.js